import { render } from "./DriversPage.vue?vue&type=template&id=7dbf7174"
import script from "./DriversPage.vue?vue&type=script&lang=js"
export * from "./DriversPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__